import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.50)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    background-color: #EFEFF9;
    height: 90%;
    z-index: 200;
    width: 100%;
    box-sizing: border-box;
    margin-top: auto;
    /* overflow-y: auto; */
    border-radius: 14px;
    padding: 40px 10%;
    .title {
      align-items: center;
      margin-bottom: 20px;
      display: flex;
      &__icon {
        font-size: 21px;
        margin: auto 5px;
      }
      &__text {
        margin-left: 5px;
        font-family: Nunito Sans;
        font-size: 20px;
      }
    }
    .panels {
      display: flex;
      height: calc(100% - 127px);
      .header {
        display: flex;
        padding: 10px;
        border-bottom: 1px solid #EFEFF9;
        justify-content: space-between;
        .toogle-container {
          width: 310px;
        }
      }
      .content-info-access {
        height: calc(100% - 56px);
      }
      .content-extra-episodes {
        height: calc(100% - 56px);
      }
      &__left {
        background-color: #FFFFFF;
        border-radius: 20px;
        width: 240px;
      }
      &__right {
        background-color: #FFFFFF;
        border-radius: 20px;
        margin-left: 10px;
        width: calc(100% - 250px);
      }
    }
    .footer {
      margin-top: 20px;
      padding: 10px 20px;
      border: 2px solid #FFFFFF;
      background-color: #E9E9F5;
      border-radius: 20px;
      .button-close {
        width: 188px;
      }
    }
  }    
`;